import React, { Component } from 'react';
import './Image.module.scss';

import generateClipPath from 'utilities/generateClipPath'

class Image extends Component {

    constructor(props) {
        super(props);
        
    }

    render() {

        const {image, width, link} = this.props.item;

        return (
            <React.Fragment>
            {
                link ?
            <a href={link} target="_blank"><img styleName='img' style={{maxWidth: width ? `${width}px` : null}} src={`/storage/${image}`} /></a>
            :
            <img styleName='img' style={{maxWidth: width ? `${width}px` : null}} src={`/storage/${image}`} />
            }
            </React.Fragment>
        );
    }
}

export default Image;
